import React from 'react';
import { FileNode } from '../../services/applications/types';

interface EditorTabsProps {
  openFiles: FileNode[];
  activeFile: string | null;
  onTabSelect: (file: FileNode) => void;
  onTabClose: (filePath: string) => void;
}

const EditorTabs: React.FC<EditorTabsProps> = ({
  openFiles,
  activeFile,
  onTabSelect,
  onTabClose
}) => {
  const getFileIcon = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'py':
        return 'fa-python text-blue-400';
      case 'json':
        return 'fa-file-code text-yellow-400';
      case 'txt':
        return 'fa-file-alt text-gray-400';
      case 'md':
        return 'fa-file-alt text-gray-400';
      case 'yml':
      case 'yaml':
        return 'fa-file-code text-red-400';
      default:
        return 'fa-file text-gray-400';
    }
  };

  if (openFiles.length === 0) {
    return (
      <div className="bg-gray-800 border-b border-gray-700 px-4 py-2">
        <span className="text-xs text-gray-500">No files open</span>
      </div>
    );
  }

  return (
    <div className="bg-gray-800 border-b border-gray-700 flex items-center overflow-x-auto">
      {openFiles.map((file) => {
        const isActive = activeFile === file.path;
        return (
          <div
            key={file.path}
            className={`
              flex items-center px-3 py-2 border-r border-gray-700 cursor-pointer
              ${isActive ? 'bg-gray-900 text-white' : 'bg-gray-800 text-gray-400 hover:bg-gray-700'}
              min-w-max
            `}
            onClick={() => onTabSelect(file)}
          >
            <i className={`fas ${getFileIcon(file.name)} mr-2 text-xs`}></i>
            <span className="text-sm mr-2">{file.name}</span>
            <button
              className="hover:bg-gray-600 rounded p-0.5"
              onClick={(e) => {
                e.stopPropagation();
                onTabClose(file.path);
              }}
            >
              <i className="fas fa-times text-xs"></i>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default EditorTabs;